import { useState, useEffect, useCallback } from 'react';
import { Calendar, Clock } from 'lucide-react';

const Countdown = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  const calculateTimeLeft = useCallback(() => {
    const difference = new Date(targetDate) - new Date();
    
    if (difference > 0) {
      setTimeLeft({
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      });
    }
  }, [targetDate]);

  useEffect(() => {
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [calculateTimeLeft]);

  const TimeUnit = ({ value, label }) => (
    <div className="flex flex-col items-center bg-white rounded-xl p-4 shadow-md min-w-[80px]">
      <div className="text-3xl md:text-4xl font-bold text-cyan-700">
        {String(value).padStart(2, '0')}
      </div>
      <div className="text-xs md:text-sm text-slate-600 mt-1 uppercase tracking-wide">
        {label}
      </div>
    </div>
  );

  return (
    <div className="bg-gradient-to-br from-slate-50 to-cyan-50 rounded-2xl p-6 md:p-8 shadow-lg">
      <div className="text-center mb-6">
        <div className="flex items-center justify-center space-x-2 mb-2">
          <Clock className="h-5 w-5 text-cyan-600" />
          <h3 className="text-xl md:text-2xl font-bold text-slate-800">Event Countdown</h3>
        </div>
        <div className="flex items-center justify-center space-x-2 text-slate-600">
          <Calendar className="h-4 w-4" />
          <p className="text-sm">September 6, 2026</p>
        </div>
      </div>
      
      <div className="flex flex-wrap justify-center gap-3 md:gap-4">
        <TimeUnit value={timeLeft.days} label="Days" />
        <TimeUnit value={timeLeft.hours} label="Hours" />
        <TimeUnit value={timeLeft.minutes} label="Minutes" />
        <TimeUnit value={timeLeft.seconds} label="Seconds" />
      </div>
    </div>
  );
};

export default Countdown;
